/**
 * This file is auto-generated. Any modifications will be
 * overwritten by the generate-icon npm script.
 */
import React from 'react';
import { SvgIcon } from "../shared/SvgIcon";
var WarningOutlineIcon = function WarningOutlineIcon(props) {
  return /*#__PURE__*/React.createElement(SvgIcon, props, /*#__PURE__*/React.createElement("path", {
    d: "M11 14V9H13V14H11Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 16H13V18H11V16Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.5435 4.18064C13.3683 2.30177 10.6317 2.30176 9.45653 4.18064L1.80811 16.4091C0.558363 18.4072 1.99482 20.9999 4.35157 20.9999H19.6484C22.0052 20.9999 23.4416 18.4072 22.1919 16.4091L14.5435 4.18064ZM11.1522 5.2412C11.5439 4.61491 12.4561 4.61491 12.8478 5.24121L20.4962 17.4696C20.9128 18.1357 20.434 18.9999 19.6484 18.9999H4.35157C3.56599 18.9999 3.08717 18.1357 3.50375 17.4696L11.1522 5.2412Z"
  }));
};
export default WarningOutlineIcon;